const pctDecrease = (oldval, newval) => {
  const pct = Math.round((100 * (newval - oldval)) / newval);
  if (Number.isNaN(pct) || !Number.isFinite(pct)) return null;
  return pct;
};
export default pctDecrease;
